import {
  IEyeParamsOption,
  IPoint,
  LensesBrandType,
  SolutionsBrandType,
} from '../../lenses/models/get-lenses.models';
import { BonusType } from '../../bonuses/models/get-bonuses.models';
import { AppointmentStoreSubType } from '../../appointments/models/get-appointments.models';

export enum ProductOwnerType {
  consumer = 'Consumer',
  dependent = 'Dependent',
}

export enum OrderType {
  clickToCollect = 'CLICK_TO_COLLECT',
  delivery = 'DELIVERY',
}

export interface ProductOwnerProfile {
  firstName: string;
  lastName: string;
  isActive: boolean;
}

export interface ProductOwner {
  type: ProductOwnerType;
  profile: ProductOwnerProfile;
  id?: string;
}

export interface DeliveryInformation {
  address?: string | null;
  consumerId?: string | null;
  createdAt?: string | null;
  deliveryDate?: string | null;
  externalOrderDeliveryId?: string | null;
  orderSystemId?: string | null;
  pickupMaxDate?: string | null;
  pickupPointId?: string | null;
  status?: string | null;
  statusHistory?: { at: string; status: string }[] | null;
  updatedAt?: string | null;
  workingHours?: string | null;
}

export interface IOrders {
  ordersByAuthId: IOrdersFields[];
  consumerLensesByAuthID: IFittingFields[];
}

export enum PotentialPointsType {
  points = 'points',
  purchaseInTimePoints = 'purchaseInTimePoints',
  cashbackPoints = 'cashbackPoints',
}

export interface PotentialPoints {
  pointsType: PotentialPointsType;
  value: number;
}

export interface IOrdersFields {
  id: string;
  orderStatus: OrderStatus;
  orderType: OrderType;
  extension?: { reason?: string };
  orderDate: string;
  lastModifiedDateTime: string;
  systemId: string;
  deliveryDate: string | null;
  oldDeliveryDate: string | null;
  products: IProduct[];
  store: IStore;
  salesforceStoreInfo: IStoreSalesforce;
  createdDateTime: string;
  voucherId: string | null;
  voucher: IOrderSelectedBonus | null;
  purchases: IOrderPurchase[];
  orderPrice?: OrderPrice;
  deliveryInformation?: DeliveryInformation | null;
  potentialPoints?: PotentialPoints[];
}

export interface IOrderPurchase {
  purchaseDate: string;
}

export interface IProduct {
  brand: LensesBrandType | SolutionsBrandType;
  eye: IEyeParamsOption[];
  packSize: number;
  productQuantity: number;
  id?: string;
  productOwner?: ProductOwner;
  productOwnerType?: ProductOwnerType;
  profileFirstName?: string;
  profileLastName?: string;
  profileIsActive?: boolean;
  profileColorIndex?: number;
  hasKidProfiles?: boolean;
}

export interface IStore {
  name: string;
  address: string;
  workingHours: string;
  phone: string;
  code: string;
  storeSubType: AppointmentStoreSubType;
  latitude?: number;
  longitude?: number;
  displayName?: string;
  city?: string;
  distance?: number;
  disabled?: boolean | null;
}

export interface IFittingFields {
  id: string;
  createdManual: boolean;
  brandId: LensesBrandType;
  brand: IOrderBrand;
}

export enum OrderStatus {
  canceledByPatient = 'CANCELED_BY_PATIENT',
  canceledAuto = 'CANCELED_AUTO',
  canceled = 'CANCELED',
  canceledAutomatically = 'CANCELED_AUTOMATICALLY',
  fulfilled = 'FULFILLED',
  confirmed = 'CONFIRMED',
  processing = 'PROCESSING',
  contactPatient = 'CONTACT_PATIENT',
  new = 'NEW',
  externalOrderCreated = 'EXTERNAL_ORDER_CREATED',
}

export interface IOrderPoints {
  brandId: LensesBrandType;
  points: IPoint[];
  hiddenForC2C?: boolean;
}

export interface IOrderBrand {
  points: IPoint[];
  hiddenForC2C?: boolean;
}

export interface VoucherProductRule {
  amount?: number;
}

export interface VoucherRules {
  exactAmountOfProductsRule?: VoucherProductRule;
  matchAmountWithProductRule?: VoucherProductRule;
}

export interface IOrderSelectedBonus {
  title: string;
  description: string | null;
  type: BonusType;
  value: number;
  name: string;
  rules?: VoucherRules;
}

export interface IStoreSalesforce {
  rating: string;
}

export interface OrderPrice {
  discount: string;
  deliveryDiscount: string;
  orderPriceWithDiscount: string;
  orderPriceWithoutDiscount: string;
}
